import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// 屏蔽 ResizeObserver loop limit exceeded 错误，这是一个已知的无关紧要的警告
const suppressResizeObserverError = (e: ErrorEvent) => {
  if (e.message.includes('ResizeObserver loop completed with undelivered notifications') ||
    e.message.includes('ResizeObserver loop limit exceeded')) {
    e.stopImmediatePropagation();
    return;
  }
};
window.addEventListener('error', suppressResizeObserverError);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

